<template>
  <div class="container">
    <div class="card">
      <div class="card-body maadi-dark-card" v-if="isLoaded" v-on:keyup.enter="submitSearch">
        <div class="m-1 text-center" style="font-size: 1.4em; font-weight: 500">
          Organization Search
        </div>
        <div class="m-1 text-center" style="font-size: 0.9em; font-weight: 300">
          <br>Use this tool to search for members and prospective members. If you need to widen your search beyond these parameters, please contact Reece or David.
        </div>
        <hr>
        <div>
          <div class="d-flex">
            <b-form-group class="flex-fill m-1" id="fieldset-1" label="Organization Name">
              <b-form-input v-model="search.name" placeholder="Enter organization name"></b-form-input>
            </b-form-group>
            <b-form-group class="m-1" label="Top 70 Member?" style="">
              <b-form-select class="d-flex" v-model="search.isTop70" :options="fields.booleanDropDown"></b-form-select>
            </b-form-group>
            <b-form-group class="m-1" label="Top Prospect?" style="">
              <b-form-select class="d-flex" v-model="search.isTopProspect" :options="fields.booleanDropDown"></b-form-select>
            </b-form-group>
            <b-form-group class="m-1" label="At Risk?" style="">
              <b-form-select class="d-flex" v-model="search.isAtRisk" :options="fields.booleanDropDown"></b-form-select>
            </b-form-group>
          </div>
          <div class="d-flex">
            <b-form-group class="m-1 flex-fill" label="Member Status" style="">
              <b-form-select class="d-flex" v-model="search.isMember" :options="fields.memberTypes"></b-form-select>
            </b-form-group>
            <b-form-group class="m-1 flex-fill" label="Member Manager" style="">
              <b-form-select class="d-flex" v-model="search.memberManager" :options="fields.memberManagers"></b-form-select>
            </b-form-group>
            <b-form-group class="m-1 flex-fill" label="2021 Membership Transaction Type" style="">
              <b-form-select class="d-flex" v-model="search.mrType" :options="[{text: '', value: null}, {text: 'JOIN', value: 'join'}, {text: 'RENEW', value: 'renew'}]"></b-form-select>
            </b-form-group>
          </div>
          <div class="d-flex" >
            <div class="d-flex flex-fill">
              <b-form-group label="Company Types" class="flex-fill mr-2">
                <b-form-select multiple id="checkbox-group-1" v-model="search.companyTypes" :options="fields.companyTypes"></b-form-select>
              </b-form-group>
            </div>
          </div>
          <!-- hiding tags for right now -->
          <div class="d-flex">
            <div class="flex-fill">
              <b-form-group class="flex-fill" label="Tags">
                <b-form-input size="sm" v-model="tagSearch.text" @keydown="onTagInput"></b-form-input>
              </b-form-group>
              <div class="d-flex" style="height: 150px; overflow-y: scroll; border: 1px solid #eeeeee; background: #FFFFFF; color: #000">
                <b-form-checkbox-group
                  class="p-1"
                  stacked
                  v-model="search.tags"
                  :options="tagSearch.filtered === null ? fields.tags : tagSearch.filtered"
                ></b-form-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn maadi-button m-1" @click="submitSearch">SUBMIT</button>
          <button class="btn maadi-button m-1" @click="resetSearch">RESET</button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="card mt-1">
        <div class="card-body maadi-dark-card justify-content-center">
          <div class="spinner-grow text-light d-flex justify-content-center flex-fill text-center" role="status" v-if="isSearching">
            <span class="sr-only">Loading...</span>
          </div>
          <div v-if="!isSearching">
            <div class="d-flex m-2" v-if="searchedOrganizations !== null">
              <div>
                Found {{ searchedOrganizations.length }} results
              </div>
              <div class="d-flex ml-auto">
                <div v-if="!isLoadingExport && exportURL === null" class="btn maadi-button" @click="exportResults" style="cursor: pointer">Export</div>
                <a v-if="!isLoadingExport && exportURL !== null" class="btn maadi-button" :href="exportURL" style="cursor: pointer"><i class="fas fa-download"></i></a>
                <div v-if="isLoadingExport" class="spinner-grow text-light" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="m-2 pb-3 pt-3 d-flex" style="border: 1px solid #3E597A" v-for="member in searchedOrganizations" :key="member.id">
              <single-organization-result-v2 v-bind:organization="member"/>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SingleOrganizationResultV2 from './SingleOrganizationResult'
import API from '../../../api/organizations'
export default {
  components: {
    SingleOrganizationResultV2
  },
  data: function () {
    return {
      isLoaded: false,
      search: null,
      previousSearch: null,
      fields: {
        booleanDropDown: [
          {text: '', value: null},
          {text: 'Yes', value: 1},
          {text: 'No', value: 0}
        ],
        dateOptions: [
          {text: 'All', value: null},
          {text: 'Before', value: 'before'},
          {text: 'After', value: 'after'}
        ],
        memberTypes: [
          {text: 'All', value: null},
          {text: 'Member', value: 1},
          {text: 'Non-Member', value: 0}
        ],
        fieldValidity: [
          {text: 'All', value: null},
          {text: 'Blank/Unknown', value: 0},
          {text: 'Valid', value: 1},
          {text: 'Invalid', value: -1}
        ],
        activityDateOptions: [
          {text: 'All', value: null},
          {text: 'Before', value: 'before'},
          {text: 'After', value: 'after'}
        ],
        membershipTypes: [],
        companyTypes: [],
        memberManagers: null,
        tags: null
      },
      tagSearch: {
        text: null,
        filtered: null
      },
      quickSearches: [
        {
          title: 'Members Without Primary Contact',
          isMember: 1,
          primaryContactValidity: 0
        },
        {
          title: 'Members Without a Member Manager',
          isMember: 1,
          memberManager: 'no_manager'
        }
      ],
      searchedOrganizations: null,
      isSearching: false,
      isLoadingExport: false,
      exportURL: null
    }
  },
  methods: {
    resetSearch () {
      this.searchedOrganizations = null
      this.search = {
        companyTypes: [],
        membershipTypes: []
      }
    },
    onTagInput: function () {
      if (this.tagSearch.text === null || this.tagSearch.text.length < 0) {
        this.tagSearch.filtered = null
        return
      }
      this.tagSearch.filtered = this.fields.tags.filter((x) => (x.text.toLowerCase().indexOf(this.tagSearch.text.toLowerCase()) > -1))
    },
    submitSearch: function () {
      this.isSearching = true
      this.searchedOrganizations = null
      API.getOrganizationsSearch_v2(this.search).then(
        response => {
          this.previousSearch = this.search
          this.searchedOrganizations = response.data.data
          this.isSearching = false
        }
      )
    },
    exportResults: function () {
      this.isLoadingExport = true
      API.getExportOfOrganizationsSearch_v2(this.previousSearch).then(
        response => {
          this.isLoadingExport = false
          if (response.result.success) {
            this.exportURL = response.result.message
          }
        }
      )
    }
  },
  mounted () {
    this.isLoaded = false
    this.$store.commit('setIsLoading', true)

    API.getOrganizationsSearchOptions_v2().then(
      response => {
        //  member managers
        let memberManagerArray = [{text: 'All Managers', value: null}, {text: 'No Manager', value: 'no_manager'}]
        this.fields.memberManagers = memberManagerArray.concat(response.data.data.member_managers)

        let tags = [{text: '', value: null}]
        this.fields.tags = tags.concat(response.data.data.tags)

        let membershipTypes = [{text: '', value: null}]
        this.fields.membershipTypes = membershipTypes.concat(response.data.data.membership_types)

        let companyTypes = [{text: '', value: null}]
        this.fields.companyTypes = companyTypes.concat(response.data.data.company_types)

        this.resetSearch()
        this.isLoaded = true
        this.$store.commit('setIsLoading', false)
      }
    )
  }
}
</script>

<style scoped>
  .title {
    font-size: 1.2em;
    color: #FFFFFF;
  }
  .sub-title {
    font-size: 0.8em;
    font-weight: 300;
  }
  .title-box {
    border-bottom: solid 1px #eee;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organizations/search/OrganizationSearch.vue